import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { ConfigName } from '../shared/shared-types';
import { CategoryLandingPage } from './category-landing-page';
import { ICategoryLandingConfig } from './category-landing-types';

if (!window.hasOwnProperty(ConfigName) || typeof (window[ConfigName]) === 'undefined') {
    throw new Error('Configuration object does not exist!');
} else {
    let config = window[ConfigName] as ICategoryLandingConfig;
    ReactDOM.render(
        <CategoryLandingPage config={config} />,
        document.getElementById('react-mount')
    );
}


// WEBPACK FOOTER //
// ./~/source-map-loader!./app/src/clp/index.tsx